<template>
	<h1 class="text-red-500 m-3">Oops ... We could not find this!</h1>
	<PButton
		@click="navigateTo('/')"
		label="Go to dashboard"
		text
	/>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'
	import Utils from '@/utils/Utils'

	export default defineComponent({
		data() {
			return {
				navigateTo: Utils.navigateTo,
			}
		},

		methods: {
		}
	})
</script>

<style></style>
